<template>
  <div class="autocomplete" id="autocomplete">
    <div class="input-wrapper" :class="{'error-input' : error && !blurred}">
      <input
        type="time"
        class="input"
        v-model="search"
        @input="onChange()"
        @click="onClick()"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        autocomplete="off">
      <span class="icon-wrapper" @click="onClickArrow">
        <img class="icon" src='@/assets/images/arrow_down.png' />
      </span>
    </div>
    <ul v-show="isOpen" class="autocomplete-results">
      <li
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter, 'italics': result === 'No entry found' }"
      >
        <span v-if="result.name == null">{{ result }}</span>
        <span v-if="result.name != null">{{ result.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "timepicker",
    props: {
      items: {
        type: Array,
        required: true,
        default: () => []
      },
      option: {
        type: String,
        required: false,
        default: () => ''
      }
    },
    data() {
      return {
        search: "",
        results: [],
        isOpen: false,
        arrowCounter: -1,
        error: false,
        blurred: false,
      };
    },
    mounted() {
      document.addEventListener("click", this.handleClickOutside);

      if (this.option != null) {
        this.search = this.option
      }
    },
    destroyed () {
      document.removeEventListener("click", this.handleClickOutside)
    },
    methods: {
      onClick() {
        this.isOpen = true;
        this.results = this.items;
        this.blurred = true;
        this.$emit("click", this.blurred);
      },
      onClickArrow() {
        this.isOpen = !this.isOpen;
        this.results = this.items;
      },
      onChange() {
        this.optionChanged(this.search)
      },
      setResult(result) {
        if (result === 'No entry found' || result.name === 'No entry found') {
          this.isOpen = true;
          this.optionChanged(result.value);
        } else {
          if (result.name != null) {
            this.search = result.value;
            this.isOpen = false;
            this.optionChanged(result.value);
          }
        }
        this.blurred = false;
        this.$emit("click", this.blurred);
      },
      onArrowDown() {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },
      onEnter() {
        this.search = this.results[this.arrowCounter].value;
        this.optionChanged(this.results[this.arrowCounter]);
        this.isOpen = false;
        this.arrowCounter = -1;
      },
      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.isOpen = false;
          this.arrowCounter = -1;
          this.blurred = false;
          this.$emit("click", this.blurred);
        }
      },
      optionChanged(value) {
        this.$emit("optionChanged", value);
      },
      setError(value) {
        this.error = value;
      },
    }
  };
</script>
